import axios, { AxiosError } from 'axios';

import toast from 'src/components/Toast';
import { ignoreThoseErrorMessages } from 'src/constants';

const UNHANDLED_ERROR_MESSAGE = 'Unexpected problem occured';

export type SuccessResponse<T> = {
  status: 'ok';
  data: T;
};
export type ErrorResponse = {
  status: 'error';
  messages: string[];
};

const instance = axios.create({
  baseURL: '/api/v1'
});

const successInterceptor = response => response.data.data;
const errorInterceptor = ({ isAxiosError, response, config }: AxiosError) => {
  // ignore automathic error handling for GET requests.
  // ignore errors from cancelled requests
  if (isAxiosError) {
    const error = response?.data;
    if (config.method !== 'get') {
      if (!error) {
        toast.error(UNHANDLED_ERROR_MESSAGE);
      }
      const errorMsg =
        error?.messages?.join(', ') || error?.message || error?.notice || error?.error || UNHANDLED_ERROR_MESSAGE;
      if (
        errorMsg &&
        !ignoreThoseErrorMessages
          .map((str: any) => {
            return str?.pathname
              ? window.location.pathname === str.pathname && errorMsg.includes(str.str)
              : errorMsg.includes(str);
          })
          .filter(Boolean).length
      ) {
        toast.error(errorMsg);
      }
    }

    return Promise.reject(error);
  }
};

instance.interceptors.response.use(successInterceptor, errorInterceptor);

export default instance;
